import getConfig from 'next/config'

/**
 * Redirects the user to the specified path across MFE domains.
 * @param path - The path to redirect to.
 */
export function mfeRedirect(path: string): void {
  const { publicRuntimeConfig } = getConfig()
  window.location.assign(`${publicRuntimeConfig.HOST_URL}${path}`)
}

/**
 * Redirects the user to the login page with the current path as a redirect parameter.
 */
export function mfeRedirectToLogin(): void {
  const { publicRuntimeConfig } = getConfig()
  const currentPath = window.location.pathname + window.location.search
  const urlParams = new URLSearchParams()
  urlParams.append('redirect', currentPath)

  window.location.assign(
    `${publicRuntimeConfig.HOST_URL}/auth/login?${urlParams.toString()}`,
  )
}
